import { Pagination } from '@/core/domain/model/pagination';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';
import { NotificationPagination } from '../../domain/model/notification_pagination';

export interface FetchNotificationRepository {
    (pagination: Pagination): Promise<NotificationPagination>
}

const fetchNotificationRepository = (axios: AxiosInstance): FetchNotificationRepository => async (pagination: Pagination) => {
    try {
        const response: AxiosResponse = await axios.get('/notification', {
            params: pagination
        })

        const notificationPagination: NotificationPagination = response.data
        return notificationPagination
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchNotificationRepository